import { VariationModel } from '@boxx/store-core';
import { createAction, props } from '@ngrx/store';

export enum StoreVariationsActionTypes {
  loadVariationsBegin = '[STORE] Load Variations Begin',
  loadVariationsSuccess = '[STORE] Load Variations Success',
  loadVariationsFail = '[STORE] Load Variations Fail',

  loadVariationByIdBegin = '[STORE] Load Variation By Id Begin',
  loadVariationByIdSuccess = '[STORE] Load Variation By Id Success',
  loadVariationByIdFail = '[STORE] Load Variation By Id Fail',

  createVariationBegin = '[STORE] Create Variation Begin',
  createVariationSuccess = '[STORE] Create Variation Success',
  createVariationFail = '[STORE] Create Variation Fail',

  deleteVariationBegin = '[STORE] Delete Variation Begin',
  deleteVariationSuccess = '[STORE] Delete Variation Success',
  deleteVariationFail = '[STORE] Delete Variation Fail',

  clearVariationsSuccessErrorData = '[STORE] Clear Variations Success/Error Data',
}

export const loadVariationsBeginAction = createAction(
  StoreVariationsActionTypes.loadVariationsBegin
);

export const loadVariationsSuccessAction = createAction(
  StoreVariationsActionTypes.loadVariationsSuccess,
  props<{ payload: VariationModel[] }>()
);

export const loadVariationsFailAction = createAction(
  StoreVariationsActionTypes.loadVariationsFail,
  props<{ errors: any }>()
);

export const loadVariationByIdBeginAction = createAction(
  StoreVariationsActionTypes.loadVariationByIdBegin,
  props<{ id: number }>()
);

export const loadVariationByIdSuccessAction = createAction(
  StoreVariationsActionTypes.loadVariationByIdSuccess,
  props<{ payload: VariationModel }>()
);

export const loadVariationByIdFailAction = createAction(
  StoreVariationsActionTypes.loadVariationByIdFail,
  props<{ errors: any }>()
);

// export const creteVariationBeginAction = createAction(
//   StoreVariationsActionTypes.createVariationBegin,
//   props<{ payload: ICreateVariationPayload }>()
// );

// export const creteVariationSuccessAction = createAction(
//   StoreVariationsActionTypes.createVariationSuccess,
//   props<{ payload: VariationModel[] }>()
// );

// export const creteVariataionFailAction = createAction(
//   StoreVariationsActionTypes.createVariationFail,
//   props<{ errors: any }>()
// );

// export const delteVariationBeginAction = createAction(
//   StoreVariationsActionTypes.deleteVariationBegin,
//   props<{ payload: number }>()
// );

export const delteVariationSuccessAction = createAction(
  StoreVariationsActionTypes.deleteVariationSuccess,
  props<{ payload: VariationModel[] }>()
);

export const delteVariationFailAction = createAction(
  StoreVariationsActionTypes.deleteVariationFail,
  props<{ errors: any }>()
);

export const clearVariationsSuccessErrorDataAction = createAction(
  StoreVariationsActionTypes.clearVariationsSuccessErrorData
);
